import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import Edit from 'react-icons/lib/md/mode-edit'
import SearchIcon from 'react-icons/lib/md/search'

import Loading from 'components/Loading'

import PanelHeader from './panel-header'
import { fetchCurriculum, fetchCurriculumSubjects } from './actions'
import ListSubjectsContainer from './list-subjects-container'
import { makeGetSubjectOptions } from './selectors'

class CurriculumsShow extends Component {

  _edit = () => {
    const { onCurriculumForm, __curriculum } = this.props
    onCurriculumForm(__curriculum)
  }

  render() {
    const {
      __curriculum,
      __subjects,
      __subjectOptions,
      params,
      onCurriculumForm,
      onSearchForm,
    } = this.props

    if (__curriculum.get('id') !== Number(params.id)) {
      return <Loading />
    }

    const header = (
      <div className="row">
        <div className="col-xs-8">
          <span>Curriculum Subjects in <strong className="text-primary">{__curriculum.get('code')}</strong></span>
        </div>
        <div className="col-xs-4 text-right">
          <button type="button" onClick={this._edit} className="btn-icon btn-inline"><Edit /></button>
          <button type="button" onClick={onCurriculumForm} className="btn-icon btn-inline">+</button>
          <button type="button" onClick={onSearchForm} className="btn-icon btn-inline"><SearchIcon /></button>
        </div>
      </div>
    )

    return (
      <PanelHeader header={header}>
        <ListSubjectsContainer
          id={__curriculum.get('id')}
          subjectList={__subjects}
          subjectOptions={__subjectOptions}
        />
      </PanelHeader>
    )
  }
}

CurriculumsShow.onEnter = (store) => (nextState) => {
  const curriculumID = Number(nextState.params.id)
  // fetch curriculum
  store.dispatch(fetchCurriculum(curriculumID))
  // fetch curriculumSubjects
  store.dispatch(fetchCurriculumSubjects(curriculumID))
}

CurriculumsShow.propTypes = {
  __curriculum: PropTypes.object,
  __subjects: PropTypes.object,
  __subjectOptions: PropTypes.array,
  onCurriculumForm: PropTypes.func,
  onSearchForm: PropTypes.func,
  params: PropTypes.object,
}

function mapStateToProps(state, props) {
  const curriculumID = Number(props.params.id)
  const getSubjectOptions = makeGetSubjectOptions()
  return {
    __curriculum: state.curriculum.get('item'),
    __subjects: state.curriculum.getIn(['items', curriculumID]),
    __subjectOptions: getSubjectOptions(state, curriculumID),
  }
}

export default connect(mapStateToProps)(CurriculumsShow)



// WEBPACK FOOTER //
// ./src/containers/Manage/Curriculums/show.js